module.exports = __webpack_public_path__ + "static/media/bookingList.242d1c1a.svg";